import React from 'react';
import BannerSectionStyle5 from '../Section/BannerSection/BannerSectionStyle5';
import Section from '../Section';
import DepartmentSectionStyle3 from '../Section/DepartmentSection/DepartmentSectionStyle3';
import BannerSectionStyle6 from '../Section/BannerSection/BannerSectionStyle6';
import { pageTitle } from '../../helpers/PageTitle';
const departmentData = [
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Custom Medicine Manufacturing',
    subTitle:
      'We offer customized production of medicines tailored to the specific requirements of healthcare providers and institutions.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Quality-Assured Nutraceuticals',
    subTitle:
      'Manufacturing a wide range of medicines, including tablets, capsules, syrups, injections, and topical solutions, adhering to stringent quality standards.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Research & Development (R&D)',
    subTitle:
      'Our R&D team is dedicated to developing innovative formulas and improving existing medications to address evolving healthcare needs.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Private Label Services',
    subTitle:
      'We provide private labeling solutions for businesses looking to market Nutraceuticals under their own brand name.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Bulk Medicine Production',
    subTitle:
      'Efficiently handling large-scale production orders to cater to hospitals, pharmacies, and distributors.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Contract Manufacturing',
    subTitle:
      'Partnering with Nutraceutical companies to provide contract manufacturing services with complete transparency and efficiency.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Regulatory Compliance',
    subTitle:
      'Ensuring all medicines are produced in compliance with local and international regulatory standards, guaranteeing safety and efficacy.',
    href: '',
  },
  {
    iconUrl: 'images/departments/icon_1.svg',
    title: 'Export Services',
    subTitle:
      'Facilitating the export of Nutraceutical products to global markets, maintaining high standards of quality and logistics.',
    href: '',
  },
];

export default function Departments() {
  pageTitle('Departments');
  return (
    <>
      <BannerSectionStyle5
        bgUrl="/images/departments/herobg.jpg"
        imgUrl="/images/departments/serv.jpg"
        title="Get to Know <br>Our Services"
        subTitle="At Sams Health Care, we specialize in delivering high-quality Nutraceutical solutions to meet the healthcare needs of our clients."
      />
      <Section bottomMd={140} bottomLg={100} bottomXl={60}>
        <DepartmentSectionStyle3 data={departmentData} />
      </Section>
      <Section className="cs_footer_margin_0">
        <BannerSectionStyle6
          imgUrl="/images/home_1/ab2.jpg"
          title="Prioritize Your Health with Our Comprehensive Services!"
          subTitle="Explore our wide range of healthcare solutions designed to meet your needs, <br>delivered by experienced medical professionals!"
        />
      </Section>
    </>
  );
}
